import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { DICT } from './dict';

const LangCtx = createContext(null);

export function LangProvider({ children }) {
    const [lang, setLang] = useState(() => {
        const saved = localStorage.getItem('surya_lang');
        if (saved) return saved;
        // Auto-detect Hindi from browser language on first visit
        try {
            const langs = (navigator.languages || [navigator.language || 'en']).map(l => (l || '').toLowerCase());
            const prefersHindi = langs.some(l => l.startsWith('hi'));
            if (prefersHindi) return 'hi';
            // Fallback: try Intl / timezone hints for UP / IST users
            const tz = Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone || '';
            if (tz === 'Asia/Kolkata' && langs.some(l => l.startsWith('en-in') || l.startsWith('hi'))) return 'hi';
        } catch { /* noop */ }
        return 'en';
    });
    useEffect(() => { localStorage.setItem('surya_lang', lang); document.documentElement.setAttribute('lang', lang); }, [lang]);

    const t = useCallback((key, fallback) => {
        const d = DICT[lang] || DICT.en;
        if (key in d) return d[key];
        if (fallback !== undefined) return fallback;
        // fallback to english if missing in hindi
        if (lang !== 'en' && key in DICT.en) return DICT.en[key];
        return key;
    }, [lang]);

    const toggle = useCallback(() => setLang(l => (l === 'en' ? 'hi' : 'en')), []);

    return (
        <LangCtx.Provider value={{ lang, setLang, toggle, t }}>
            {children}
        </LangCtx.Provider>
    );
}

export function useLang() {
    const ctx = useContext(LangCtx);
    if (!ctx) throw new Error('useLang must be used within LangProvider');
    return ctx;
}
